import { useApi } from '@omnipresentgroup/api';
import type { UpdateEmployeeOnboardingProgressRequest } from '@omnipresentgroup/types';
import { useMutation } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useEmployeeOnboardingProgressMutation = ({
  employeeId,
}: {
  employeeId: string;
}) => {
  const { PATCH } = useApi();

  return useMutation({
    mutationFn: (payload: UpdateEmployeeOnboardingProgressRequest) => {
      return PATCH({
        path: `${API_BASE}/${API_PATH}/employee/${employeeId}`,
        body: payload,
      });
    },
  });
};
